<template>
  <div class="group-list">
    <div class="accordion-evn">
      <div v-if="groupType_ === 'normal'">
        <Accordion :group="freeCalls" :extra-data="extraData">
          <template v-for="slot in possibleChildSlotsFor('FreeCallsInside')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Accordion>
        <Accordion :group="calls" :extra-data="extraData">
          <template v-for="slot in possibleChildSlotsFor('CallsInside')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Accordion>
        <Accordion :group="sms" :extra-data="extraData">
          <template v-for="slot in possibleChildSlotsFor('Sms')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Accordion>
        <Accordion :group="freeSms" :extra-data="extraData">
          <template v-for="slot in possibleChildSlotsFor('FreeSms')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Accordion>
        <Accordion :group="mms" :extra-data="extraData">
          <template v-for="slot in possibleChildSlotsFor('Mms')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Accordion>
        <Accordion :group="freeMms" :extra-data="extraData">
          <template v-for="slot in possibleChildSlotsFor('FreeMms')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Accordion>
      </div>
      <div v-if="groupType_ === 'other'">
        <Accordion :group="freeServiceCalls" :extra-data="extraData">
          <template v-for="slot in possibleChildSlotsFor('FreeServiceCalls')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Accordion>
        <Accordion :group="other" :extra-data="extraData">
          <template v-for="slot in possibleChildSlotsFor('Other')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Accordion>
        <Accordion :group="serviceCalls" :extra-data="extraData">
          <template v-for="slot in possibleChildSlotsFor('ServiceCalls')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Accordion>
      </div>
      <div v-if="groupType_ === 'topUpAndVoucher'">
        <Accordion :group="topUp" :group-type="groupType_" :extra-data="extraData">
          <template v-for="slot in possibleChildSlotsFor('TopUp')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Accordion>
        <Accordion :group="voucher" :group-type="groupType_" :extra-data="extraData">
          <template v-for="slot in possibleChildSlotsFor('Voucher')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Accordion>
      </div>
    </div>
  </div>
</template>

<script>

import Accordion from './Accordion.vue'
import slotProxy from '../../../../../mixins/slotProxy'

export default {
  name: 'ItemisedBillingGroupList',
  components: {
    Accordion
  },
  mixins: [
    slotProxy()
  ],
  computed: {
    group_: function () {
      return this.group
    },
    freeCalls: function () {
      return this.group_?.freePhoneCalls
    },
    calls: function () {
      return this.group_?.phoneCalls
    },
    freeSms: function () {
      return this.group_?.freeSms
    },
    sms: function () {
      return this.group_?.sms
    },
    mms: function () {
      return this.group_?.mms
    },
    freeMms: function () {
      return this.group_?.freeMms
    },
    freeServiceCalls: function () {
      return this.group_?.freeServiceCalls
    },
    other: function () {
      return this.group_?.other
    },
    serviceCalls: function () {
      return this.group_?.serviceCalls
    },
    topUp: function () {
      return this.group_?.topUp
    },
    voucher: function () {
      return this.group_?.voucher
    },
    groupType_: function () {
      return this.groupType
    }
  },
  props: {
    group: {
      type: Object,
      default: () => {}
    },
    groupType: {
      type: String,
      default: 'normal'
    },
    extraData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
  }
}
</script>
